import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CharacterCounterComponent } from './components/character-counter/character-counter.component';
import { CollapsibleContainerComponent } from './components/collapsible-container/collapsible-container.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import { SaveAndContinueLaterComponent } from './components/save-and-continue-later/save-and-continue-later.component';
import { SoldoFieldErrorComponent } from './components/soldo-field-error/soldo-field-error.component';
import { SoldoFieldLayoutComponent } from './components/soldo-field-layout/soldo-field-layout.component';
import { SoldoTooltipComponent } from './components/soldo-tooltip/soldo-tooltip.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TypefaceIconComponent } from './components/typeface-icon/typeface-icon.component';
import { AbandonNoticeComponent } from './dialog-contents/abandon-notice/abandon-notice.component';
import { CompanySearchDetailModalComponent } from './dialog-contents/company-search-detail-modal/company-search-detail-modal.component';
import { SaveAndContinueComponent } from './dialog-contents/save-and-continue/save-and-continue.component';
import { UboHelpComponent } from './dialog-contents/ubo-help/ubo-help.component';
import { UnsupportedMarketComponent } from './dialog-contents/unsupported-market/unsupported-market.component';
import { InteractiveElementDirective } from './directives/interactive-element.directive';
import { TrimWhitespacesDirective } from './directives/trim-whitespaces.directive';
import { AmplitudeService } from './services/amplitude.service';
import { DynatraceHelperService } from './services/dynatraceHelper.service';
import { GoogleTagManagerService } from './services/google-tag-manager.service';
import { ItalianTownsService } from './services/italian-towns.service';
import { MarketoIntegrationService } from './services/marketo-integration.service';
import { LoadingScreenService } from './services/loading-screen.service';
import { ModalDialogService } from './services/modal-dialog.service';
import { RegistrationWebappPushApiService } from './services/registration-webapp-push-api.service';
import { StepService } from './services/steps.service';
import { UppercaseDirective } from './directives/uppercase.directive';
import { Address3Component } from './components/address3/address3.component';
import { GoogleMapsAddressService } from './services/google-maps-address.service';
import { Address3DefaultComponent } from './components/address3/address3-default/address3-default.component';
import { Address3ItalyComponent } from './components/address3/address3-italy/address3-italy.component';
import { Address3IrelandComponent } from './components/address3/address3-ireland/address3-ireland.component';
import { Address3UkComponent } from './components/address3/address3-uk/address3-uk.component';
import { Address3UsaComponent } from './components/address3/address3-usa/address3-usa.component';
import { GooglePlacesSearchFieldComponent } from './components/address3/google-places-search-field/google-places-search-field.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        NgSelectModule,
        UppercaseDirective
    ],
    declarations: [
        HeaderComponent,
        CollapsibleContainerComponent,
        SoldoFieldLayoutComponent,
        SoldoFieldErrorComponent,
        TypefaceIconComponent,
        Address3Component,
        SaveAndContinueLaterComponent,
        ModalDialogComponent,
        LoadingScreenComponent,
        SpinnerComponent,
        UboHelpComponent,
        SaveAndContinueComponent,
        AbandonNoticeComponent,
        CompanySearchDetailModalComponent,
        UnsupportedMarketComponent,
        TrimWhitespacesDirective,
        InteractiveElementDirective,
        SoldoTooltipComponent,
        CharacterCounterComponent,
        Address3DefaultComponent,
        Address3ItalyComponent,
        Address3IrelandComponent,
        Address3UkComponent,
        Address3UsaComponent,
        GooglePlacesSearchFieldComponent
    ],
    providers: [
        ItalianTownsService,
        StepService,
        ModalDialogService,
        LoadingScreenService,
        GoogleMapsAddressService,
        AmplitudeService,
        MarketoIntegrationService,
        GoogleTagManagerService,
        RegistrationWebappPushApiService,
        DynatraceHelperService
    ],
    exports: [
        HeaderComponent,
        CollapsibleContainerComponent,
        SoldoFieldLayoutComponent,
        SoldoFieldErrorComponent,
        TypefaceIconComponent,
        Address3Component,
        SaveAndContinueLaterComponent,
        ModalDialogComponent,
        LoadingScreenComponent,
        SpinnerComponent,
        UboHelpComponent,
        SaveAndContinueComponent,
        TrimWhitespacesDirective,
        InteractiveElementDirective,
        SoldoTooltipComponent,
        CharacterCounterComponent
    ]
})
export class SharedModule {}
